"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.removeSuffix = exports.oneGraphifyName = void 0;
var caseUtils_1 = require("./caseUtils");
function oneGraphifyName(name) {
    for (var _i = 0, _a = ["__c", "__r", "__pc", "__pr"]; _i < _a.length; _i++) {
        var suffix = _a[_i];
        if (name.endsWith(suffix)) {
            return (0, caseUtils_1.camelCase)(removeSuffix(name, suffix)) + suffix;
        }
    }
    return (0, caseUtils_1.camelCase)(name);
}
exports.oneGraphifyName = oneGraphifyName;
function removeSuffix(str, suffix) {
    if (str.endsWith(suffix)) {
        return str.substring(0, str.length - suffix.length);
    }
    return str;
}
exports.removeSuffix = removeSuffix;
